import React from "react";

const Error = () => {
  return (
    <div className="o-appointment">
      <div className="o-appointment__container">
        <span>
          😥 Ups, hubo un problema obteniendo las opciones de agendamiento, por
          favor intenta de nuevo más tarde.
        </span>
      </div>
    </div>
  );
};

export default Error;
